
<template>
  <div class="enroll-audit-page">
    <yxt-page-header :title="language().tit_sign_up" @back="backRouter"></yxt-page-header>
    <audit-detail :loading="loading" :record="record" ></audit-detail>
  </div>
</template>

<script>

import auditDetail from '../../components/manage/auditDetail.vue';

export default {
  name: 'signupManageDetail',
  inject: ['language'],
  props: {
    id: {
      type: String,
      default: ''
    },
    projectId: {
      type: String,
      default: ''
    }
  },
  components: { auditDetail },
  data() {
    return {
      record: {},
      loading: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    backRouter() {
      this.$emit('toManage', this.projectId);
    },
    async getData() {
      this.loading = true;
      const SDK = this.$parent.SDK;
      this.record = await SDK.getRecordDetail(this.id);
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.enroll-audit-page {
  .lh56 {
    flex-shrink: 0;
    height: 56px;
  }
}
</style>
